/**
* Получение элементов кокретного клаькулятора с привязкой к его id
*/
import UICommon from './common';
class UIQuery {
    id;
    constructor(id) {
        this.id = id;
    }
    /**
    *
    * @param string type
    * @return HTMLElement | null container element of type, for calculator with specific id
    *
    */
    container(type) {
        return document.querySelector(`.calculator-container-${type}[data-calculator-id="${this.id}"]`);
    }
    containers() {
        return document.querySelectorAll(`*[data-calculator-id="${this.id}"]`);
    }
    one(subPath, type = 'main') {
        if (type === '') {
            return document.querySelector(`*[data-calculator-id="${this.id}"] ${subPath}`);
        }
        else {
            return document.querySelector(`.calculator-container-${type}[data-calculator-id="${this.id}"] ${subPath}`);
        }
    }
    all(subPath, type = 'main') {
        if (type === '') {
            let conts = this.containers();
            if (conts.length) {
                let res = Array.from(conts).map((itm) => {
                    return Array.from(itm.querySelectorAll(subPath));
                });
                return res.flat(1);
            }
        }
        else {
            let cont = this.container(type);
            if (cont) {
                return Array.from(cont.querySelectorAll(subPath));
            }
        }
        return [];
    }
    findAndUpdateStyle(query, map, type = 'main') {
        let el = this.one(query, type);
        if (el) {
            UICommon.updateStyle(el, map);
        }
    }
    findAllAndUpdateStyle(query, map, type = 'main') {
        if (Array.isArray(query)) {
            query.forEach((subQuery) => {
                this.findAllAndUpdateStyle(subQuery, map, type);
            });
        }
        else {
            let subQueries = query.split(',');
            if (subQueries.length > 1) {
                subQueries.forEach((subQuery) => {
                    this.findAllAndUpdateStyle(subQuery, map, type);
                });
            }
            else {
                let els = this.all(query, type);
                if (els) {
                    Array.from(els).forEach(el => UICommon.updateStyle(el, map));
                }
            }
        }
    }
}
export default UIQuery;
